
import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('user')
import { RInput, RButton, RSelect, RCard } from '@/components'

const cats = [
  'Account registration',
  'Computer setup & connectivity',
  'Drive setup & access',
  'Payments & billing',
  'Something else',
]

type BugState = {
  category: string | null
  availableBugCategories: string[]
  description: string
  expectedResult?: string
  additionalDetails?: string
}

export default Vue.extend({
  name: 'BugReport',
  components: {
    RInput,
    RButton,
    RSelect,
    RCard,
  },
  data(): BugState {
    return {
      category: null,
      availableBugCategories: cats,
      description: '',
      expectedResult: '',
      additionalDetails: '',
    }
  },
  methods: {
    submit() {
      const { category, description, expectedResult, additionalDetails, userAgent } = this
      this.reportBug({
        category,
        description,
        expectedResult,
        additionalDetails,
        userAgent,
      })
    },
    ...mapActions(['reportBug']),
  },
  computed: {
    userAgent() {
      return window.navigator.userAgent
    },
    ...mapGetters(['bugReportRequest']),
    submitDisabled(): boolean {
      return this.bugReportRequest.pending || !this.category || !this.description
    },
  },
  watch: {
    bugReportRequest(newValue) {
      if (newValue.successful) {
        this.description = ''
        this.category = null
      }
    },
  },
})
